import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView, useSpring, useTransform } from 'framer-motion';
function Counter({
  value,
  suffix = ''
}: {
  value: number;
  suffix?: string;
}) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const spring = useSpring(0, {
    duration: 2500,
    bounce: 0
  });
  const displayValue = useTransform(spring, current => Math.floor(current));
  useEffect(() => {
    if (isInView) {
      spring.set(value);
    }
  }, [isInView, value, spring]);
  return <span ref={ref} className="flex items-baseline" data-id="element-155">
      <motion.span data-id="element-156">{displayValue}</motion.span>
      {suffix}
    </span>;
}
const stats = [{
  value: 500,
  suffix: '+',
  label: 'Унікальних подій'
}, {
  value: 10,
  suffix: '+',
  label: 'Років досвіду'
}, {
  value: 15,
  suffix: '',
  label: 'Країн світу'
}, {
  value: 50,
  suffix: 'k+',
  label: 'Задоволених гостей'
}];
export function Stats() {
  return <section className="py-32 bg-background border-b border-border" data-id="element-157">
      <div className="container mx-auto px-6 md:px-12" data-id="element-158">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-12 md:gap-0 divide-y md:divide-y-0 md:divide-x divide-border" data-id="element-159">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 1,
          delay: index * 0.1
        }} className={`flex flex-col items-center justify-center ${index > 0 ? 'pt-12 md:pt-0' : ''}`} data-id="element-160">
              <h4 className="text-6xl md:text-7xl lg:text-8xl font-serif text-primary mb-6 font-light" data-id="element-161">
                <Counter value={stat.value} suffix={stat.suffix} data-id="element-162" />
              </h4>
              <p className="text-secondary font-sans text-[10px] uppercase tracking-super-wide" data-id="element-163">
                {stat.label}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}